<template lang='pug'>
  //- Shop-Product-Subscribe-Detail
  div(:class='$style[`cc-shop-subscribe-detail`]')
    div(v-if='preloading' :class='$style[`cc-shop-subscribe-detail-main`]')
      div(:class='$style[`cc-shop-subscribe-detail-loading`]')
        IconLoading(:size='36' :color='`#262626`')

    div(v-else :class='$style[`cc-shop-subscribe-detail-main`]')
      router-link(
        v-if='subscribeDetail.prev'
        title='上一個方案'
        tag='button'
        tabindex='0' aria-label='上一個方案'
        :to='`/shop/subscribe/${subscribeDetail.prev}`'
        :class='[$style[`cc-shop-subscribe-detail-prev`], $style[`cc-shop-subscribe-detail-btn`]]')
        != '←'
        span 上一個方案

      router-link(
        v-if='subscribeDetail.next'
        title='下一個方案'
        tag='button'
        tabindex='0' aria-label='下一個方案'
        :to='`/shop/subscribe/${subscribeDetail.next}`'
        :class='[$style[`cc-shop-subscribe-detail-next`], $style[`cc-shop-subscribe-detail-btn`]]') 
        != '→'
        span 下一個方案

      div(:class='$style[`cc-shop-subscribe-detail-left`]')

        figure(:class='$style[`cc-shop-subscribe-detail-photo`]')
          img(:src='`${STATIC_URL}images/${subscribeDetail.mallSrc}`' width='100%' height='100%' loading='lazy')

        //- div(:class='$style[`cc-shop-subscribe-detail-origin`]')
        //-   span 諮詢顧問：
        //-   router-link(:to='`/team/${subscribeDetail.mallTeam}`' :class='$style[`cc-shop-subscribe-detail-merchandise`]') {{ subscribeDetail.teamName }}

        button.btn-extra(
          title='分享此商品'
          tabindex='0' aria-label='分享此商品'
          :class='$style[`cc-shop-subscribe-detail-share`]'
          @click='handleShowQRcodePopBox') 分享此商品


      div(:class='$style[`cc-shop-subscribe-detail-right`]')
        span(:class='$style[`cc-shop-subscribe-detail-tag`]') 訂閱方案

        div(:class='$style[`cc-shop-subscribe-detail-title`]')
          span.font-medium {{ subscribeDetail.mallName }}

        div(:class='$style[`cc-shop-subscribe-detail-detail`]')
          //- div(:class='$style[`cc-shop-subscribe-detail-twoway`]') 兩種購買方式(2擇1)
          //- div(:class='$style[`cc-shop-subscribe-detail-cost`]') 
          //-   div(:class='$style[`cc-shop-subscribe-detail-cost-space`]') C幣兌換
          //-   div(v-if='subscribeDetail.mallCoin' :class='$style[`cc-shop-subscribe-detail-cost-coin`]')
          //-     IconCcoin(:size='22')
          //-     span.font-bold {{ subscribeDetail.mallCoin }}
          //- span(:class='$style[`cc-shop-subscribe-detail-or`]') /

          div(:class='$style[`cc-shop-subscribe-detail-cost`]') 
            div(:class='$style[`cc-shop-subscribe-detail-cost-space`]') 優惠價
            div(:class='$style[`cc-shop-subscribe-detail-cost-price`]')
              IconMoney(:size='22' color='#262626')
              span.font-bold {{ subscribeDetail.mallPrice ? subscribeDetail.mallPrice : '免費試用' }}

          span(:class='$style[`cc-shop-subscribe-detail-or`]') /

          span.font-medium(v-if='subscribeDetail.mallQuotaLeft === `unlimit`' :class='$style[`cc-shop-subscribe-detail-quota-left`]') 沒名額限制
          span.font-medium(v-else :class='$style[`cc-shop-subscribe-detail-quota-left`]') {{ `剩餘名額 ${subscribeDetail.mallQuotaLeft}` }}


        div(:class='$style[`cc-shop-subscribe-detail-panel`]')
          router-link.btn-extra(
            tag='button'
            title='返回方案列表'
            tabindex='0' aria-label='返回方案列表'
            to='/shop/subscribe'
            :class='$style[`cc-shop-subscribe-detail-return`]') 返回方案列表

          router-link.btn-extra(
            v-if='this.isAdded && this.isAiDoctor'
            tag='button'
            title='已訂閱，開始使用'
            tabindex='0' aria-label='已訂閱，開始使用'
            to='/aidoctor'
            :class='$style[`cc-shop-subscribe-detail-valid`]') 已訂閱，開始使用

          router-link.btn-extra(
            v-else-if='this.isAdded'
            tag='button'
            title='已訂閱，開始使用'
            tabindex='0' aria-label='已訂閱，開始使用'
            to='/sideeffect/record'
            :class='$style[`cc-shop-subscribe-detail-valid`]') 已訂閱，開始使用

          button.btn-extra(
            v-else
            title='立即訂閱'
            tabindex='0' aria-label='立即訂閱'
            :class='$style[`cc-shop-subscribe-detail-subscribe`]'
            @click='handleStartPurchaseProcess') 立即訂閱


        div(:class='$style[`cc-shop-subscribe-detail-describe`]')
          header.font-medium(:class='$style[`cc-content-wrap-header`]') 方案內容
          span(:class='$style[`cc-content-wrap-info`]' v-html='subscribeDetail.mallContant')


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { useShare } from '@vueuse/core'
const { share, isSupported } = useShare();

import { debounce } from 'debounce';
import IconCcoin from '../../icon/Ccoin';
import IconMoney from '../../icon/Money';
import IconConfirm from '../../icon/Confirm';
import IconLoading from '../../icon/Loading';

import {
  getLoadShopItemDetail,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: `${this.subscribeDetail.mallName}`,
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: `https://cancell.tw/shop/subscribe/${this.sid}`,
      }],
      link: [{
        rel: 'canonical',
        href: `https://cancell.tw/shop/subscribe/${this.sid}`,
      }],
    };
  },

  components: {
    IconCcoin,
    IconMoney,
    IconConfirm,
    IconLoading,
  },

  props: {
    sid: {
      type: String,
      default: '',
    },
  },

  created() {
    this.initPageOnLoad();
    console.log('this.$store.state.route.from.fullPath', this.$store.state.route.from.fullPath);
  },

  data() {
    return {
      preloading: true,
      subscribeDetail: {},
      isAiDoctor: false,
      isAdded: false,
      nextTick: 1,
      mallCount: 1,
    };
  },

  methods: {
    ...mapMutations({
      addUserShopCart: 'user/USER_SHOP_ADDCART',
      // removeUserShopCart: 'user/USER_SHOP_REMOVECART',
      resetAllUserShopCart: 'user/USER_SHOP_REMOVECART_ALL',
      changeUserShopStep: 'user/USER_SHOP_STEP',
      // changeQRcodeStatus: 'global/POPQRCODE_STATUS',
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    async initPageOnLoad() {
      // await this.checkIsSubscribed();
      await this.axiosShopMallLoadDetail();
    },

    handleStartPurchaseProcess() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
        return;
      }

      if (this.isAiDoctor) {
        if (this.subscribeDetail.mallCode === 'ai_free') {
          this.changePopBoxStatus({
            active: true,
            include: 'freeSubscribe',
          });
        } else {
          this.handleControlCartStatus();
        }
      } else {
        if (this.loginProfile.user_type === 'doctor') {
          this.changePopBoxStatus({
            active: true,
            include: 'warnNotDoctor',
          });
        } else if (!this.loginEproActive) {
          this.changePopBoxStatus({
            active: true,
            include: 'createPersonalData',
          });
        } else {
          this.handleControlCartStatus();
        }
      }
    },

    axiosShopMallLoadDetail() {
      getLoadShopItemDetail(`?type=subscribe&id=${this.sid}`)
        .then((res) => {
          
          this.subscribeDetail = res.data;
          this.preloading = false;
          if (res.data.mallCode === 'ai_free' || res.data.mallCode === 'ai_a') {
            this.isAiDoctor = true;
          }

          if (this.loginStatus) {
            this.loginSubscribeValid.map((x) => {
              if (x.serviceName === res.data.mallCode) {
                this.isAdded = true;
              }
            });
          }
          console.log('RES', this.isAdded, this.isAiDoctor);
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.$router.replace({name: 'error404'}).catch(() => true);
          }
        })
    },

    async handleControlCartStatus() {
      await this.resetAllUserShopCart()
      await this.controlCartDebounceEvent();
    },

    controlCartDebounceEvent: debounce(function (e) {
      const ADD_DATA = {
        cartType: 'subscribe',
        id: this.subscribeDetail.id,
        mallCount: '1',
        mallCode: `${this.subscribeDetail.mallCode}-${this.subscribeDetail.mallTeam}`,
        mallCoin: this.subscribeDetail.mallCoin,
        mallPrice: this.subscribeDetail.mallPrice,
        mallFoodType: '訂閱方案',
        mallLink: '',
        mallSrc: this.subscribeDetail.mallSrc,
        mallPeriod: this.subscribeDetail.mallPeriod,
        mallTitle: this.subscribeDetail.mallName,
      }

      const newProcess = new Promise((resolve) => {
        this.$router.push('/shop/subscribe').catch(() => true);
        this.addUserShopCart(ADD_DATA);
        return resolve('ok');
      });

      newProcess.then((value) => {
        if (value === 'ok') {
          this.changeUserShopStep(1);
        }
      });

      // console.log('refreshMyCart', this.myShopCart);
    }, 200),

    handleShowQRcodePopBox() {
      share({
        title: 'Cancell醫抗癌 訂閱方案',
        text: this.subscribeDetail.mallName,
        url: `https://cancell.tw/shop/subscribe/${this.sid}`,
      });
    },

    // handleShowQRcodePopBox() {
    //   this.changeQRcodeStatus({
    //     active: true,
    //     link: `https://cancell.tw/shop/subscribe/${this.sid}`,
    //   });
    // },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      loginSubscribeValid: 'user/exportUserSubscribeValid',
      loginEproActive: 'user/exportEproSetupActive',
      // myShopCart: 'user/exportUserShopCart',
      // loginSubscribeExpire: 'user/exportUserSubscribeExpire',
    }),
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/shop/shopProductSubscribeDetail.scss';
</style>
